'use strict';

var $isNaN = require('../helpers/isNaN');

// https://ecma-international.org/ecma-262/6.0/#sec-samevaluezero

module.exports = function SameValueZero(x, y) {
	return (x === y) || ($isNaN(x) && $isNaN(y));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-abstract/2021/SameValueZero.js
// module id = 235
// module chunks = 1